import {IF, nil, UIRoute, UITextView, UIView, UIViewController, YES} from "uicore-ts"
import {CompanyViewController} from "../CompanyView/CompanyViewController"
import {RHCore} from "../Core/RHCore"
import {RHFocusManager} from "../Custom components/RH/Keyboard navigation/RHFocusManager"
import {RHPageFocusManager} from "../Custom components/RH/Keyboard navigation/RHPageFocusManager"
import {RHAlertBannerView} from "../Custom components/RH/RHAlertBannerView"
import {RHButton} from "../Custom components/RH/RHButton"
import {RHColor} from "../Custom components/RH/RHColor"
import {RHSpacing} from "../Custom components/RH/Utils_slop/RHDesignTokens"
import {RHProcurerMainViewTokens} from "../Custom components/RH/Utils_slop/RHViewTokens"


// Shown instead of NewProcurementViewController when the active company has not
// configured any contracting-authority type yet - a procurement can't be created
// without one. Only company administrators can fix this
// (CompanyAffiliationViewController.contractingAuthoritySettingsView), so only
// they get the button; everyone else is told to ask an administrator.
export class ContractingAuthorityNotConfiguredViewController extends UIViewController {
    
    readonly bannerView = new RHAlertBannerView().configuredWithObject({
        alertType: RHAlertBannerView.type.Warning,
        textAlignment: UITextView.textAlignment.center
    }).addedAsSubviewToView(this.view)
    
    readonly openCompanySettingsButton = new RHButton().configuredWithObject({
        titleLabel: {text: "Ava ettevõtte seaded"},
        controlEventTargetAccumulator: {
            PrimaryActionTriggered: () => {
                UIRoute.currentRoute
                    .routeByRemovingComponentsOtherThanOnesNamed(["settings"])
                    .routeWithViewControllerComponent(CompanyViewController, nil)
                    .apply()
            }
        }
    })
    
    override _focusManager = new RHFocusManager(() =>
        IF(this.openCompanySettingsButton.superview === this.view)(
            () => [this.openCompanySettingsButton]
        ).ELSE(() => [])
    )
    
    
    constructor(view: UIView) {
        super(view)
        this.view.configureWithObject({backgroundColor: RHColor.background})
    }
    
    
    override async viewWillAppear() {
        await super.viewWillAppear()
        RHPageFocusManager.shared.registerContentControllerManager(this._focusManager)
        const isAdministrator = RHCore.sharedInstance.companyAffiliationStore
            .activeCompanyAffiliation?.isAdministrator === YES
        this.bannerView.configuredWithObject({
            text: isAdministrator
                ? "Sinu ettevõttel pole hankija määratlust seadistatud. Enne hanke loomist tuleb " +
                "ettevõtte seadetes valida vähemalt üks hankija määratlus."
                : "Sinu ettevõttel pole hankija määratlust seadistatud. Hanke loomiseks palu " +
                "ettevõtte administraatoril seadistada vähemalt üks hankija määratlus."
        })
        if (isAdministrator) {
            this.openCompanySettingsButton.addedAsSubviewToView(this.view)
        } else {
            this.openCompanySettingsButton.removeFromSuperview()
        }
        this.view.setNeedsLayoutUpToRootView()
    }
    
    
    override async viewWillDisappear() {
        await super.viewWillDisappear()
        RHPageFocusManager.shared.deregisterContentControllerManager(this._focusManager)
    }
    
    
    override layoutViewSubviews() {
        super.layoutViewSubviews()
        const padding = this.core.paddingLength
        const bounds = this.view.contentBoundsWithInset(padding)
            .rectangleWithMaxWidth(1100, 0.5)
        bounds
            .rectangleByAddingY(RHSpacing.medium)
            .rectangleWithHeight(this.bannerView)
            .assignedAsFrameOfView(this.bannerView)
            .IF(this.openCompanySettingsButton.superview === this.view)
            .rectangleForNextRow(padding, RHProcurerMainViewTokens.actionButtonHeight)
            .rectangleWithWidth(RHProcurerMainViewTokens.actionButtonWidth + 50, 0.5)
            .assignedAsFrameOfView(this.openCompanySettingsButton)
            .ENDIF()
    }
}
